import { useFlag } from '@calendly/feature-check-react'
import moment from 'moment-timezone'

import { useGetUserQuery } from 'common'
import { useFetchContactByEmailGQLQuery } from 'features/contacts'
import { CRM_MEETING_PREP_MVP_FLAG_KEY } from 'features/crm'
import { useCurrentTime } from 'shared/contexts'

export const useGenerateMeetingPrep = (event) => {
  const { data: currentUser } = useGetUserQuery()
  const currentTime = useCurrentTime()
  const meetingPrepFlag = useFlag(CRM_MEETING_PREP_MVP_FLAG_KEY)
  const oneOnOneMeeting = event.attendees?.length === 2
  const meetingInNext7Days = moment(event.startTime).isBetween(
    currentTime,
    currentTime.clone().add(7, 'days'),
    null,
    '[]'
  )
  const getContactEmail = () => {
    if (!currentUser) return undefined
    if (currentUser.email === event.host?.email) {
      return event.invitee?.email
    }
    return event.host?.email
  }
  const contactEmail = getContactEmail()
  const { data: contact, isLoading: isContactLoading } = useFetchContactByEmailGQLQuery(contactEmail, {
    skip: !contactEmail || !oneOnOneMeeting || !meetingInNext7Days || !meetingPrepFlag || event.cancelled,
  })
  const showGenerateMeetingPrep = (
    meetingPrepFlag
    && oneOnOneMeeting
    && meetingInNext7Days
    && !event.cancelled
    && contact
    && !isContactLoading
  )

  return { showGenerateMeetingPrep, contact }
}
